/* eslint-disable */
(() => {
  const template = document.createElement('template');
  template.innerHTML = `
<div class="swinger-accordion">
  <details class="swinger-accordion__item">
    <summary class="swinger-accordion__item-title">
        <span class="swinger-accordion__item-title-text"></span>
        <svg class="swinger-accordion__indicator"><use xlink:href="#swinger-svg-spritesheet-chevron-down"></use></svg>
    </summary>
    <div class="swinger-accordion__item-content"></div>
  </details>
</div>
`;

  window.swinger.observer.initialize('details:not([class])', (elem) => {
    window.requestAnimationFrame(() => {
      const summary = elem.querySelector('summary');

      if (!summary) {
        return;
      }

      elem.removeChild(summary);
      const childNodes = Array.prototype.slice.call(elem.childNodes);
      const accordion = document.createElement('div');
      accordion.className = 'swinger-accordion';
      accordion.innerHTML = `<details class="swinger-accordion__item">
        <summary class="swinger-accordion__item-title">
            <span class="swinger-accordion__item-title-text"></span>
            <svg class="swinger-accordion__indicator"><use xlink:href="#swinger-svg-spritesheet-chevron-down"></use></svg>
        </summary>
        <div class="swinger-accordion__item-content"></div>
      </details>`;
      const accordionSummary = accordion.querySelector('.swinger-accordion__item-title-text');
      accordionSummary.innerHTML = summary.innerHTML;
      const accordionContent = accordion.querySelector('.swinger-accordion__item-content');
      childNodes.forEach((node) => { accordionContent.appendChild(node); });
      elem.parentNode.replaceChild(accordion, elem);
    });
  }, false);
})();
